// extracted by mini-css-extract-plugin
export var speaker_image = "speaker-image-module--speaker_image--2VLeU";
export var orange = "speaker-image-module--orange--1SQY9";
export var purple = "speaker-image-module--purple--By-xh";
export var center = "speaker-image-module--center--3n5fx";
export var image = "speaker-image-module--image--18IpD";
export var up = "speaker-image-module--up--14Gnp";
export var image_data = "speaker-image-module--image_data--2vKim";
export var down = "speaker-image-module--down--57vxV";